import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

const GetTeacherStudentReviewCountsQuery = gql`
  query getTeacherStudentReviewCounts($teacherIds: [String!]!) {
    getTeacherStudentReviewCounts(teacherIds: $teacherIds) {
      teacherId
      totalReviews
    }
  }
`;

export function useTeacherStudentReviewCounts(teacherIds: string[]) {
  const { data, loading } = useQuery(GetTeacherStudentReviewCountsQuery, {
    variables: { teacherIds },
    skip: teacherIds.length === 0,
    fetchPolicy: "cache-and-network",
  });

  const reviewCountByTeacherId = useMemo(() => {
    const list: { teacherId: string; totalReviews: number }[] =
      data?.getTeacherStudentReviewCounts ?? [];
    return new Map(list.map((r) => [r.teacherId, r.totalReviews]));
  }, [data]);

  return { reviewCountByTeacherId, loading };
}
